export default "__VITE_ASSET__DAUbiHl2__"